import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ViewerService {
  public preventAllSubscriptions$ = new Subject();
  public uiGridWasChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  private _createNewPreventState(): void {
    this.preventAllSubscriptions$ = new Subject();
  }

  preventAllSubscriptions(): void {
    this.preventAllSubscriptions$.next(undefined);
    this.preventAllSubscriptions$.complete();

    this._createNewPreventState();
  }
}
